import gql from 'fraql'
import {fragments} from './fragments'

export const COURIERS_DELIVERY_QUERY = gql`
query {
  deliveriesCourier {
    nodes {
      id,
      idDay,
      creationTime,
      ordersByIdDelivery {
        nodes {
           ${fragments.courierOrdersItem}
        }
      }
      status: stageDeliveryByIdStageDelivery {
        name,
        keyword
      }
    }
  }
}
`
export const COURIERS_CURRENT_DELIVERY_QUERY = gql`
query DeliveriesCourierActive {
  deliveriesCourierActive {
    nodes {
      id
      idDay
      idStageDelivery
      ordersByIdDelivery {
        nodes {
          ${fragments.courierOrdersItem}
        }
      }
      status: stageDeliveryByIdStageDelivery {
        name,
        keyword
      }
    }
  }
}
`
export const COURIERS_COMPLETED_DELIVERY_QUERY = gql`
query DeliveriesCourierComplete ($dateFrom: Date!, $dateTo: Date) {
  deliveriesCourierComplete(dateFrom: $dateFrom, dateTo: $dateTo) {
    nodes {
      id
      idDay
      idStageDelivery
      ordersByIdDelivery {
        nodes {
          ${fragments.courierOrdersItem}
        }
      }
      status: stageDeliveryByIdStageDelivery {
        name,
        keyword
      }
    }
  }
}
`
export const CONFIRM_COURIER_ORDER = gql`
mutation UpdatePayment ($id: Int!, $cash: BigFloat!, $cardInPlace: BigFloat!, $discount: BigFloat, $cause: String, $paymentChanged: Boolean) {
  updateOrderSumPayment(input: {idOrd: $id, cash: $cash, cardInPlace: $cardInPlace, discount: $discount, cause: $cause, paymentChanged: $paymentChanged}) {
    integer
  }
}
`
export const ORDERS_COLD_COOKER = gql`
query {
  tasksColdCooker {
    nodes {
      ${fragments.coldWorkshopTasks}
    }
  }
}`
export const ORDERS_COLD_CUTTER = gql`
query {
  tasksColdCutter {
    nodes {
      ${fragments.coldWorkshopTasks}
    }
  }
}`
export const ORDERS_HOT_COOKER = gql`
query {
  tasksHotCooker {
    nodes {
      ${fragments.hotWorkshopTasks}
    }
  }
}`
export const TASKS_PIZZA_ROLLER = gql`
query {
  tasksPizzaRoller {
    nodes {
      ${fragments.pizzaTasks}
    }
  }
}`
export const TASKS_PIZZA_COOKER = gql`
query {
  tasksPizzaCooker {
    nodes {
      ${fragments.pizzaTasks}
    }
  }
}`
export const TASKS_PIZZA_COLLECTOR = gql`
query {
  tasksPizzaCollector {
    nodes {
      ${fragments.pizzaWorkshopTasks}
    }
  }
}`
export const SIGNIN_MUTATION = gql`
  mutation Signin($email: String!, $password: String!) {
    signin(input:{
      email: $email,
      password: $password
    }) {
      jwtToken
    }
  }
`
export const SIGNIN_AFTER_HANDLER = gql`
  mutation {
    signinAfterHandler (input: {}) {
      boolean
    }
  }
`
export const ORDER_PAYMENT_BY_ID_ORDER_QUERY = gql`
  query OrderPaymentByIdOrder($idOrder: Int!) {
    orderPaymentByIdOrder(idOrder: $idOrder) {
        id
        cash
        cardOnline
        cardInPlace
        sberbank
        payed
        paymentLink
    }
}
`
export const TYPE_PAYMENT_QUERY = gql`
  query {
    activeTypesPayment {
      nodes {
        id,
        name,
        keyword
      }
    }
  }
`
export const TYPE_WORKSHOPS = gql`
  query AllTypeWorkshops {
    allTypeWorkshops {
      nodes {
        id
        name
        keyword
      }
    }
  }
`
export const TYPE_STAGE_WORKSHOPS = gql`
  query AllStageWorkshops {
    allStageWorkshops {
      nodes {
        idType
        active
        keyword
        name
      }
    }
  }
`
export const TYPE_DELIVERY_QUERY = gql`
  query {
    allTypeDeliveries {
      nodes {
        id,
        name,
        keyword
      }
    }
  }
`
export const TYPE_DISCOUNT_QUERY = gql`
  query {
    getTypesDiscount {
      nodes {
        id,
        name,
        keyword,
        comment
      }
    }
  }
`
export const REST_POINT_QUERY = gql`
  query {
   allRestPoints(condition: {active: true}) {
     nodes {
       id,
       address,
       location
     }
   }
  }
`
export const STATUS_QUERY = gql`
  query {
    allStageOrders(condition: {active: true}) {
      nodes {
        id,
        name,
        keyword
      }
    }
  }
`
export const ACTIVE_BRANDS_QUERY = gql`
  query {
    allBrands(condition: {active: true}) {
      nodes {
        id,
        name,
        cats: categoriesByIdBrand(condition: {active: true, parentId: 0}, orderBy: NAME_ASC) {
          nodes {
            id,
            name,
            prods: products {
              nodes {
                ${fragments.product}
              }
            }
          }
        }
      }
    }
  }
`
export const COLLECTING_ORDERS_QUERY = gql`
  query OrdersCollectingFiltered($stageId: Int, $dayId: Int) {
    ordersCollectingFiltered(stageId: $stageId, dayId: $dayId) {
      nodes  {
        ${fragments.collectorOrdersItem}
      }
    }
  }
`
export const ALL_PRODUCTS_QUERY = gql`
  query {
    allProducts {
      nodes {
        id
        name
        idBrand
        idOrigin
        cost: price
        pricePoints
        maxDiscount
        pizzaSize
        burger
      }
    }
  }
`
export const PRODUCTS_QUERY = gql`
  query Products($order: Int!) {
    allProductOrders(condition: {idOrder: $order}) {
      nodes {
        id,
        idBrand,
        idProduct,
        name,
        count,
        cost: price,
        pricePoints,
        group,
        deleted,
        collected,
        smallSize,
        categoryByIdCategory {
          id
          sort
        }
      }
    }
  }
`
export const SEARCH_ADD_PRODS_QUERY = gql`
  query {
    searchDopCat {
      nodes {
        id,
        name,
        extraFor,
        prods: productsByIdCategory {
          nodes {
            id,
            name,
            cost: price,
            maxDiscount
          }
        }
      }
    }
  }
`
export const WORKSHOP_CHANGE_STAGE = gql`
    mutation updateTask($id: Int!, $taskWorkshopPatch: TaskWorkshopPatch!) {
        updateTaskWorkshopById(input: {id: $id, taskWorkshopPatch: $taskWorkshopPatch}) {
            taskWorkshop {
                id
                stageWorkshop
            }
        }
    }
`
export const UPDATE_WORKER_BY_ID = gql`
    mutation updateWorker ($id: Int!, $workerPatch: WorkerPatch!) {
      updateWorkerById(input: {id: $id, workerPatch: $workerPatch}) {
            worker {
              nodeId
            }
        }
    }
`
export const UPDATE_ORDER_MUTATE = gql`
  mutation UpdateOrder ($id: Int!, $orderPatch: OrderPatch!) {
    res: updateOrderById(input: {id: $id, orderPatch: $orderPatch}) {
      order {
        nodeId
      }
    }
  }
`
export const SOFT_DELETE_ORDER = gql`
  mutation UpdateOrder($id: Int!, $orderPatch: OrderPatch!) {
    res: updateOrderById(input: {id: $id, orderPatch: $orderPatch}) {
      order {
        nodeId
      }
    }
  }
`
export const UPDATE_PRODUCT_ORDER_MUTATE = gql`
  mutation UpdateOrderProd ($id: Int!, $productOrderPatch: ProductOrderPatch!) {
    res: updateProductOrderById(input: {id: $id, productOrderPatch: $productOrderPatch}) {
      productOrder {
        id,
        nodeId,
        count
      }
    }
  }
`
export const UPDATE_DELIVERY = gql`
  mutation UpdateDelivery ($id: Int!, $deliveryPatch: DeliveryPatch!) {
    res: updateDeliveryById(input: {id: $id, deliveryPatch: $deliveryPatch}) {
      delivery {
        id,
        nodeId
      }
    }
  }
`
export const UPDATE_WORKER_STATUS_MUTATE = gql`
  mutation updateWorkerStatus ($idWorker: Int!, $status: Boolean!, $idStage: Int, $deliverySum: BigFloat) {
    updateWorkerStatus(input: {idw:$idWorker, status: $status, stage: $idStage, deliverySum: $deliverySum}) {
      boolean
    }
  }
`
export const UPDATE_ORDER_DELIVERY = gql`
  mutation updateOrderDelivery ($idOrder: Int!, $idDelivery: Int, $idCourier: Int, $idStage: Int) {
    updateOrderDelivery(input: {idOrder: $idOrder, idDelivery: $idDelivery, idCourier: $idCourier, idStage: $idStage}) {
      integer
    }
  }
`
export const UPDATE_ORDER_PRIORITY = gql`
  mutation updateOrderPriority ($idOrder: Int!, $priority: Int!) {
    updateOrderPriority(input: {idOrder: $idOrder, priority: $priority}) {
      integer
    }
  }
`
export const CREATE_PRODUCT_ORDER_MUTATE = gql`
  mutation CreateProductOrder($productOrder: ProductOrderInput!) {
    createProductOrder(input: {productOrder: $productOrder}) {
      productOrder {
        id
      }
    }
  }
`
export const CREATE_ORDER_MUTATE = gql`
  mutation CreateOrder($order: OrderInput!) {
    createOrder(input: {order: $order}) {
      order {
        id,
        idDay
      }
    }
  }
`
export const DELETE_PRODUCT_ORDER = gql`
  mutation DeleteProductOrder($id: Int!) {
    deleteProductOrderById(input: {id: $id}) {
      deletedProductOrderId
    }
  }
`
export const DELETE_ORDER = gql`
  mutation DeleteOrder($id: Int!) {
    deleteOrderById(input: {id: $id}) {
      deletedPOrderId
    }
  }
`
export const ALL_CLIENTS_BY_BRAND = gql`
  query {
    allBrands(condition: {active: true}) {
      nodes {
        id,
        clients: clientsByIdBrand {
          nodes {
             id,
            name,
            phone,
            discount,
            allowPoints
          }
        }
      }
    }
  }
`
export const ORDERS_BY_PHONE = gql`
  query OrderQuery($idBrand: Int!, $phone: String!) {
    allOrders(condition: {idBrand: $idBrand, phone: $phone}, orderBy: TIME_DESC) {
      nodes {
        ${fragments.orderInfo}
        ${fragments.orderProducts}
      }
    }
  }
`
export const TYPE_WORKSHOPS_QUERY = gql`
  query {
    allTypeWorkshops {
      nodes {
        id,
        name,
        keyword
      }
    }
  }
`
export const BRANDS_QUERY = gql`
  query {
    allBrands(condition: {active: true}) {
      nodes {
        id,
        name
      }
    }
  }
`

export const DELIVERY_ORDERS_QUERY = gql`
  query {
    deliveryOrders {
      nodes {
        ${fragments.logistycOrdersItem}
      }
    }
  }
`
export const PICKUP_ORDERS_QUERY = gql`
  query PickupOrdersByDay ($day: Date) {
    pickupOrdersByDay (day: $day) {
      nodes {
        ${fragments.orderInfo}
        ${fragments.paymentInfo}
        ${fragments.statusesOrder}
      }
    }
  }
`
export const FREE_COURIERS_QUERY = gql`
  query {
    allWorkers(condition: {
      keywordPos: "courier",
      active: true,
      onWorkNow: false
    }) {
      nodes {
        id,
        firstName,
        lastName,
        secondName,
        phoneNumber,
        onWorkNow,
        deliverySum,
        idRestPoint,
        status: stageWorkerByIdStageWorker {
          name,
          keyword
        }
      }
    }
  }
`
export const REST_POINT_COURIERS_QUERY = gql`
  query ($idRestPoint: Int!) {
    allWorkers(condition: {
      keywordPos: "courier",
      active: true,
      idRestPoint: $idRestPoint,
      onWorkNow: true
    }) {
      nodes {
        id,
        firstName,
        lastName,
        secondName,
        phoneNumber,
        onWorkNow,
        deliverySum,
        idRestPoint,
        idStageWorker
      }
    }
  }
`
export const STAGES_WORKERS_QUERY = gql`
  query {
    allStageWorkers(condition: {idPositionWorker: 4, active: true}) {
      nodes {
        id,
        name,
        keyword
      }
    }
  }
`
export const STAGES_DELIVERY_QUERY = gql`
  query {
    allStageDeliveries(condition: {active: true}) {
      nodes {
        id,
        name,
        keyword
      }
    }
  }
`
export const DELIVERY_ZONES = gql`
  query {
    allDeliveryZones {
      nodes {
        id,
        idRestPoint,
        polygon,
        deliveryPrice,
        clientPrice,
        restPoint: restPointByIdRestPoint {
          address,
          cords: location
        }
      }
    }
  }
`
export const DELIVERIES_QUERY = gql`
  query {
    deliveriesLogistic {
      nodes {
        id,
        approximTime
        status: stageDeliveryByIdStageDelivery {
          id,
          name,
          keyword
        },
        courier: workerByIdCourier {
          id,
          firstName,
          lastName,
          secondName,
          phoneNumber,
          onWorkNow,
          status: stageWorkerByIdStageWorker {
            name,
            keyword
          }
        }
        ordersRaw: ordersInside {
          nodes {
            ${fragments.logistycDeliverysOrderItem}
          }
        }
      }
    }
  }
`
export const CREATE_DELIVERY = gql`
  mutation CreateDelivery($delivery: DeliveryInput!) {
    createDelivery(input: {delivery: $delivery}) {
      delivery {
        id
      }
    }
  }
`
export const DELETE_DELIVERY = gql`
    mutation DeleteDelivery($id: Int!) {
    deleteDeliveryById(input: {id: $id}) {
      deletedDeliveryId
    }
  }
`
export const UPDATE_ORDER_COLLECTED = gql`
  mutation updateOrderCollected($idOrder: Int!){
    updateOrderCollected(input: {idOrder: $idOrder}) {
      integer
    }
  }
`
export const PRINT_TASK = gql`
  mutation printTask($idTask: Int!){
    printTask(input: {idTask: $idTask}) {
      boolean
    }
  }
`
export const COURIER_STATS = gql`
  query CouriersDeliveriedOrders($day: Date!) {
      couriersDeliveriedOrders(day: $day) {
          nodes {
              id
              idDay
              priceDelivery
              idCourier
              price: sum
              coordsClosed
              paymentChanged
              paymentChangingMarked
              ymapsDistance
              autoAssignCourier
              stageKeyword
              status: stageOrderByIdStage {
                id,
                name,
                keyword
              }
              delivery: deliveryByIdDelivery {
                id,
                restpoint: restPointByIdRestPoint {
                  ${fragments.point}
                },
                deliveryStatuses: statusDeliveriesByIdDelivery {
                  nodes {
                    stage: stageDeliveryByIdStage {
                      name,
                      keyword
                    },
                    time
                  }
                },
              }
              ${fragments.paymentInfo}
              ${fragments.statusesOrder}

              workerByIdCourier {
                id
                lastName
                firstName
                secondName
                phoneNumber
              }
          }
      }
  }
`
export const COURIER_DELIVERIED_ORDERS = gql`
  query CourierDeliveriedOrders ($workerID: Int!, $day: Date, $showAll: Boolean) {
    courierDeliveriedOrders(workerid: $workerID, day: $day, showAll: $showAll) {
      nodes {
        id
        idDay
        priceDelivery
        idCourier
        price: sum
        coordsClosed
        paymentChanged
        paymentChangingMarked
        ymapsDistance
        autoAssignCourier
        status: stageOrderByIdStage {
          id,
          name,
          keyword
        }
        delivery: deliveryByIdDelivery {
          id,
          restpoint: restPointByIdRestPoint {
            ${fragments.point}
          },
          deliveryStatuses: statusDeliveriesByIdDelivery {
            nodes {
              stage: stageDeliveryByIdStage {
                name,
                keyword
              },
              time
            }
          },
        }
        ${fragments.paymentInfo}
        ${fragments.statusesOrder}
      }
    }
  }
`
export const CREATE_SPENDING = gql`
  mutation CreateSpending ($spending: SpendingInput!) {
    createSpending (input: {spending: $spending}) {
      spending {
        id
      }
    }
  }
`
export const DELETE_SPENDING = gql`
  mutation DeleteSpending ($id: Int!) {
    deleteSpendingById (input: {id: $id}) {
      deletedSpendingId
    }
  }
`
export const SPENDINGS_BY_DATE = gql`
  query($day: Date!, $showAll: Boolean) {
    answer: spendingsByDate(day: $day, showAll: $showAll) {
      nodes {
        id,
        title,
        sum,
        confirmed
      }
    }
  }
`
export const CLOSE_SHIFT = gql`
  mutation {
    closeShift (input: {}) {
      boolean
    }
  }
`
export const SHIFT_CLOSE = gql`
  mutation {
    shiftClose (input: {}) {
      integer
    }
  }
`
export const SHIFT_COURIERS_CHECK = gql`
  query {
    shiftCouriersCheck
  }
`
export const GET_SHIFT_LOGISTIAN_BY_DAY = gql`
  query ($day: Date!, $idW: Int) {
    getShiftLogistianByDay (day: $day, idWorker: $idW) {
      dateOpened
      dateClosed
      idWorker
    }
  }
`
export const COURIER_STATS_INDIVIDUAL = gql`
  query ($day: Date!) {
    courierStats(day: $day) {
      nodes {
        id
        idDay
        priceDelivery
        idCourier
        price: sum
        coordsClosed
        delivery: deliveryByIdDelivery {
          id,
          restpoint: restPointByIdRestPoint {
            ${fragments.point}
          },
        }
        ${fragments.paymentInfo}
        ${fragments.statusesOrder}
      }
    }
  }
`
export const BATCH_UPDATE_PRODUCT_COLLECTED = gql`
  mutation ProductsCollectedBatchUpdate($ids: [Int!]!, $collected: Boolean!) {
    productsCollectedBatchUpdate(input: { productOrderIds: $ids, flag: $collected }) {
      boolean
    }
  }
`
export const LIST_PROMOCODES = gql`
  query {
    allPromocodes(condition: {active: true}) {
      nodes {
        id
        promocode
        idBrand
        idTypeDiscount
        sumDiscount
        description
        active
        title
      }
    }
  }
`
export const PRINT_REPORT_COURIERS_ORDERS = gql`
  mutation printReportCouriersOrders($date: Date!) {
    printReportCouriersOrders(input: {date: $date}) {
      string
    }
  }
`
export const PRINT_INVOICE = gql`
  mutation printInvoice($idOrder: Int!) {
    printInvoice(input: {idOrder: $idOrder}) {
      clientMutationId
    }
  }
`
export const UPDATE_COMBO_PAYMENT = gql`
  mutation updateComboOrderPayment ($idOrder: Int!, $paymentPayload: PaymentItemInput) {
    updateComboOrderPayment (input: {idOrder: $idOrder, paymentpayload: $paymentPayload}) {
      boolean
    }
  }
`
export const LOG_FROM_CRM = gql`
  mutation logFromCrm ($message: JSON!, $category: String!, $level: String!, $userId: String! ) {
    logFromCrm(input: { message: $message, category: $category, level: $level, userId: $userId }) {
      boolean
    }
  }
`
export const ORDER_INFO_MANAGEMENT = gql`
  query ($id: Int! ) {
    orderInfoManagement(orderId: $id) {
        info
        typePayment
        client
        brand
        point
        typeDelivery
        discountType
        status
        courier
        statuses
        shift
        workerAccept
        workshop
        paymentOnlyInfo
        promocode
    }
  }
`
export const COURIER_MONTH_STAT = gql`
  query CourierMonthStat ($mnth: Date!) {
    courierMonthStat(mnth: $mnth) {
      ordcnt
      salary
    }
  }
`
export const SH_FIND_TARGET_RESTOURANT = gql`
  mutation ShFindTargetRestourant ($address: String!) {
    shFindTargetRestourant(input: { arg0: $address }) {
      string
    }
  }
`
export const SH_GEOCODE_CRM = gql`
  mutation ShGeocodeCrm ($address: String!) {
    shGeocodeCrm(input: { arg0: $address }) {
      string
    }
  }
`



// WEBPACK FOOTER //
// ./src/constants/graphql.js